import { AppointmentListingModel, IModel, ModelRecord } from '@common/models';
import { ICheckInModel } from '@models/forms/ICheckInModel';
import { defaultTo } from 'lodash';
export interface IAppointmentCheckInRequest extends IModel {
  reservationId: number;
  veterinarianId: number;
  veterinarianFirstName: string;
  veterinarianLastName: string;
  veterinarianEmailName: string;
  veterinarianLicenseNumber: string;
  veterinarianLicenseStateId: number | undefined;
  veterinarianLicenseExpirationDate: string;
  createAsInProgress: boolean;
  dispensingAuthUserId: number | undefined;
  dispensingUserFirstName: string | undefined;
  dispensingUserLastName: string | undefined;
  reasonForVisit: string | undefined;
  appointmentNotes: string | undefined;
  intakeNotes: string | undefined;
  weight: number | undefined;
  room: string | undefined;
}

export class AppointmentCheckInRequest
  implements ModelRecord<IAppointmentCheckInRequest>
{
  reservationId: number;
  veterinarianId: number;
  veterinarianFirstName: string;
  veterinarianLastName: string;
  veterinarianEmailName: string;
  veterinarianLicenseNumber: string;
  veterinarianLicenseStateId: number | undefined;
  veterinarianLicenseExpirationDate: string;
  createAsInProgress: boolean;
  dispensingAuthUserId: number | undefined;
  dispensingUserFirstName: string | undefined;
  dispensingUserLastName: string | undefined;
  reasonForVisit: string | undefined;
  appointmentNotes: string | undefined;
  intakeNotes: string | undefined;
  weight: number | undefined;
  room: string | undefined;
  rowVersion: string;

  constructor(params: Partial<IAppointmentCheckInRequest>) {
    const {
      reservationId = 0,
      veterinarianId = 0,
      veterinarianFirstName = '',
      veterinarianLastName = '',
      veterinarianEmailName = '',
      veterinarianLicenseNumber = '',
      veterinarianLicenseStateId = undefined,
      veterinarianLicenseExpirationDate = '',
      createAsInProgress = false,
      rowVersion = '',
    } = params;

    this.reservationId = reservationId;
    this.veterinarianId = veterinarianId;
    this.veterinarianFirstName = veterinarianFirstName;
    this.veterinarianLastName = veterinarianLastName;
    this.veterinarianEmailName = veterinarianEmailName;
    this.veterinarianLicenseNumber = veterinarianLicenseNumber;
    this.veterinarianLicenseStateId = veterinarianLicenseStateId;
    this.veterinarianLicenseExpirationDate = veterinarianLicenseExpirationDate;
    this.createAsInProgress = createAsInProgress;
    this.dispensingAuthUserId = defaultTo(
      params?.dispensingAuthUserId,
      undefined,
    );
    this.dispensingUserFirstName = defaultTo(
      params?.dispensingUserFirstName,
      '',
    );
    this.dispensingUserLastName = defaultTo(params?.dispensingUserLastName, '');
    this.reasonForVisit = defaultTo(params?.reasonForVisit, '');
    this.appointmentNotes = defaultTo(params?.appointmentNotes, '');
    this.intakeNotes = defaultTo(params?.intakeNotes, '');
    this.weight = defaultTo(params?.weight, undefined);
    this.room = defaultTo(params?.room, '');
    this.rowVersion = rowVersion;
  }

  static FromListingModel(
    model: AppointmentListingModel,
    checkInModel: ICheckInModel,
    createAsInProgress: boolean = false,
  ) {
    return new AppointmentCheckInRequest({
      reservationId: model.reservationId,
      // We send vetId, and not other details on vet because we want vet in db to be source of truth.
      veterinarianId: model.veterinarianId,

      // We send first and last name here to save a fetch on the backend.
      dispensingAuthUserId: model.dispensingAuthUserId,
      dispensingUserFirstName: model.dispensingUserFirstName,
      dispensingUserLastName: model.dispensingUserLastName,

      appointmentNotes: checkInModel.appointmentNotes,
      intakeNotes: checkInModel.intakeNotes,
      reasonForVisit: checkInModel.reasonForVisit,
      weight: checkInModel.weight,
      room: checkInModel.room,
      rowVersion: model.rowVersion,
      createAsInProgress: createAsInProgress,
    });
  }
}
